export default __webpack_public_path__ + "static/media/S500W_Gallery_09.ae06dac4.jpg";